// iter156 — Kullanıcı ilgi tracking (çerez benzeri localStorage)
// Kategoriye tıklama/görüntüleme kaydı → anasayfa personalizasyonu
const KEY = "bordo:pref:cats:v1";
const MAX = 40;

export function trackCategoryView(categoryId) {
  if (!categoryId) return;
  try {
    const raw = localStorage.getItem(KEY);
    const data = raw ? JSON.parse(raw) : {};
    data[categoryId] = (data[categoryId] || 0) + 1;
    data.__at = Date.now();
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch { /* ignore */ }
}

export function trackProductView(product) {
  if (!product?.primary_category_id) return;
  trackCategoryView(product.primary_category_id);
}

export function getTopCategoryIds(limit = 6) {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const data = JSON.parse(raw);
    const entries = Object.entries(data).filter(([k]) => !k.startsWith("__"));
    entries.sort((a, b) => b[1] - a[1]);
    return entries.slice(0, limit).map(([k]) => k);
  } catch { return []; }
}
